var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluesuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.899922,
    y: 0.901387,
    width: 15.197,
    height: 15.197,
    rx: 7.59852,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2308 5.70044L7.0985 10.8328L4.76562 8.49989",
    stroke: "white",
    strokeWidth: 1.59969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.899922,
    y: 0.901387,
    width: 15.197,
    height: 15.197,
    rx: 7.59852,
    stroke: "#6F00FF",
    strokeWidth: 0.799844
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluesuccess);
export default __webpack_public_path__ + "static/media/bluesuccess.6d3b4c8502fd15097e0adf5b69236415.svg";
export { ForwardRef as ReactComponent };